export const GET_SCHOOL_CODES = 'auth/GET_SCHOOL_CODES';
export const GENERATE_SCHOOL_CODES = 'auth/GENERATE_SCHOOL_CODES';
